// assets/a24-landing-df250aun-kuro.js
(function () {
  'use strict';

  function normalizeIndex(idx, length) {
    // Kreisnavigation für Carousel und Lightbox.
    if (!length) return 0;
    return (idx + length) % length;
  }

  function initHighPriceModal(root) {
    // Initialisiert den Beratungs-CTA und befuellt das vorhandene High-Price-Modal.
    var openBtn = root.querySelector('[data-kuro-contact-open]');
    if (!openBtn || openBtn.dataset.a24KuroModalReady === 'true') return;
    openBtn.dataset.a24KuroModalReady = 'true';

    var modal = document.getElementById('highPriceContactModal');
    var closeEls = modal ? modal.querySelectorAll('[data-modal-close]') : [];
    var titleEl = document.getElementById('highPriceContactModalTitle');
    var motorProductEl = document.getElementById('motorContactProduct');
    var motorVariantEl = document.getElementById('motorContactVariant');
    var motorPriceEl = document.getElementById('motorContactPrice');
    var motorProductInput = document.getElementById('motorContactProductInput');
    var motorVariantInput = document.getElementById('motorContactVariantInput');
    var motorPriceInput = document.getElementById('motorContactPriceInput');
    var motorBodyField = document.getElementById('motorContactBody');
    var copyCheckbox = document.getElementById('motorContactCopyCheckbox');
    var copyRequestedInput = document.getElementById('motorContactCopyRequestedInput');
    var postedFlag = document.getElementById('highPriceContactPostedFlag');
    var toast = document.getElementById('highPriceContactToast');

    var productTitle = root.getAttribute('data-kuro-product-title') || root.getAttribute('data-kuro-title') || '';
    var variantLabel = root.getAttribute('data-kuro-variant-label') || 'Standard';
    var priceLabel = root.getAttribute('data-kuro-price-label') || 'Auf Anfrage';
    var fallbackLink = root.getAttribute('data-kuro-cta-primary-link') || '';

    if (!modal) {
      openBtn.addEventListener('click', function (event) {
        if (window.A24Theme?.shouldProtectEditorClicks?.()) return;
        if (fallbackLink) window.location.href = fallbackLink;
      });
      return;
    }

    function buildBodyTemplate() {
      // Standardtext für das Kontaktformular, solange der Nutzer nicht selbst editiert.
      return [
        'Hallo,',
        '',
        'ich interessiere mich für folgenden Motor und bitte um Beratung:',
        '- Produkt: ' + productTitle,
        '- Variante: ' + variantLabel,
        '- Preis: ' + priceLabel,
        '',
        'Bitte kontaktieren Sie mich mit Verfügbarkeit und Angebot.',
        ''
      ].join('\n');
    }

    function syncCopyRequestedState() {
      // Spiegelt die Kopie-Checkbox in ein verstecktes Formularfeld.
      if (!copyRequestedInput) return;
      if (!copyCheckbox) {
        copyRequestedInput.value = 'Ja';
        return;
      }
      copyRequestedInput.value = copyCheckbox.checked ? 'Ja' : 'Nein';
    }

    function updateModalFields() {
      // Schreibt Produkt-, Varianten- und Preisdaten in sichtbare und versteckte Felder.
      if (titleEl) titleEl.textContent = 'Anfrage für ' + productTitle;
      if (motorProductEl) motorProductEl.textContent = productTitle;
      if (motorVariantEl) motorVariantEl.textContent = variantLabel;
      if (motorPriceEl) motorPriceEl.textContent = priceLabel;
      if (motorProductInput) motorProductInput.value = productTitle;
      if (motorVariantInput) motorVariantInput.value = variantLabel;
      if (motorPriceInput) motorPriceInput.value = priceLabel;
      if (motorBodyField && motorBodyField.dataset.userEdited !== 'true') {
        motorBodyField.value = buildBodyTemplate();
      }
      syncCopyRequestedState();
    }

    function openModal() {
      // Oeffnet das Kontaktmodal und sperrt den Seiten-Scroll über die bestehende Klasse.
      updateModalFields();
      modal.hidden = false;
      document.body.classList.add('modal-open');
    }

    function closeModal() {
      // Schliesst das Kontaktmodal und gibt den Seiten-Scroll wieder frei.
      modal.hidden = true;
      document.body.classList.remove('modal-open');
    }

    function showSuccessToast() {
      // Zeigt nach erfolgreichem Formular-Post kurz die Rückmeldung an.
      if (!toast) return;
      toast.hidden = false;
      window.setTimeout(function () {
        toast.hidden = true;
      }, 4200);
    }

    openBtn.addEventListener('click', function (event) {
      if (window.A24Theme?.shouldProtectEditorClicks?.()) return;
      event.preventDefault();
      openModal();
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (motorBodyField) {
      motorBodyField.addEventListener('input', function () {
        motorBodyField.dataset.userEdited = 'true';
      });
    }

    if (copyCheckbox) {
      copyCheckbox.addEventListener('change', syncCopyRequestedState);
    }

    if (postedFlag) showSuccessToast();
    updateModalFields();
  }

  function initStandardLightbox(root) {
    // Eine section-weite Lightbox für alle Trigger mit data-lightbox-src.
    var lightbox = root.querySelector('[data-a24-lightbox]');
    if (!lightbox || lightbox.dataset.a24LightboxReady === 'true') return;
    lightbox.dataset.a24LightboxReady = 'true';

    var dialog = lightbox.querySelector('.a24-lightbox__dialog');
    var lightboxImage = lightbox.querySelector('[data-a24-lightbox-image]');
    var lightboxCaption = lightbox.querySelector('[data-a24-lightbox-caption]');
    var lightboxPrev = lightbox.querySelector('[data-a24-lightbox-prev]');
    var lightboxNext = lightbox.querySelector('[data-a24-lightbox-next]');
    var lightboxClose = Array.prototype.slice.call(lightbox.querySelectorAll('[data-a24-lightbox-close]'));
    var lightboxItems = [];
    var lightboxIndex = 0;
    var lastFocusedElement = null;
    var touchStartX = 0;
    var touchStartY = 0;

    function getTriggers() {
      // Sammelt bei jedem Öffnen die aktuellen Bilder, damit Editor-Reloads stabil bleiben.
      return Array.prototype.slice.call(root.querySelectorAll('[data-lightbox-src]')).filter(function (trigger) {
        return !!String(trigger.getAttribute('data-lightbox-src') || '').trim();
      });
    }

    function buildItems(trigger) {
      // Baut aus den Triggern eine navigierbare Bildliste und merkt den Startindex.
      var triggers = getTriggers();
      var items = triggers.map(function (item) {
        var image = item.querySelector('img');
        return {
          src: String(item.getAttribute('data-lightbox-src') || '').trim(),
          alt: String(item.getAttribute('data-lightbox-alt') || (image && image.alt) || '').trim(),
          trigger: item
        };
      });

      return {
        items: items,
        index: Math.max(0, triggers.indexOf(trigger))
      };
    }

    function updateNavState() {
      // Bei nur einem Bild werden Prev/Next ausgeblendet.
      var hasMany = lightboxItems.length > 1;
      if (lightboxPrev) lightboxPrev.hidden = !hasMany;
      if (lightboxNext) lightboxNext.hidden = !hasMany;
    }

    function renderLightbox() {
      // Rendert aktuelles Bild, Alt-Text und Zaehler in der Lightbox.
      if (!lightboxItems.length || !lightboxImage) return;

      var item = lightboxItems[lightboxIndex];
      var label = item.alt || 'Bildvorschau';
      var counter = lightboxItems.length > 1 ? (lightboxIndex + 1) + ' / ' + lightboxItems.length : '';

      lightboxImage.src = item.src;
      lightboxImage.alt = label;

      if (lightboxCaption) {
        lightboxCaption.textContent = counter ? label + ' - ' + counter : label;
      }

      updateNavState();
    }

    function preloadLightboxAround() {
      // Laedt Nachbarbilder vor, damit Pfeil- und Swipe-Navigation weich bleibt.
      if (!lightboxItems.length) return;

      for (var offset = -2; offset <= 2; offset += 1) {
        if (offset === 0) continue;
        var preloadIndex = normalizeIndex(lightboxIndex + offset, lightboxItems.length);
        var preloadSrc = lightboxItems[preloadIndex] && lightboxItems[preloadIndex].src;
        if (!preloadSrc) continue;
        var preloadImg = new Image();
        preloadImg.src = preloadSrc;
      }
    }

    function openLightbox(trigger) {
      // Oeffnet die Lightbox beim angeklickten Bild und setzt Fokus/Scroll-Zustand.
      var data = buildItems(trigger);
      if (!data.items.length) return;

      lightboxItems = data.items;
      lightboxIndex = normalizeIndex(data.index, lightboxItems.length);
      lastFocusedElement = document.activeElement;
      renderLightbox();
      preloadLightboxAround();

      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('a24-lightbox-open');

      window.requestAnimationFrame(function () {
        (dialog || lightbox).focus({ preventScroll: true });
      });
    }

    function closeLightbox() {
      // Schliesst die Lightbox, entfernt das aktive Bild und stellt den Fokus wieder her.
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('a24-lightbox-open');

      if (lightboxImage) lightboxImage.removeAttribute('src');

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus({ preventScroll: true });
      }
    }

    function stepLightbox(delta) {
      // Navigiert vor/zurück, inklusive Wrap-around.
      if (!lightboxItems.length) return;
      lightboxIndex = normalizeIndex(lightboxIndex + delta, lightboxItems.length);
      renderLightbox();
      preloadLightboxAround();
    }

    root.addEventListener('click', function (event) {
      // Event-Delegation: neue/neu gerenderte Slides funktionieren ohne erneutes Binding.
      var trigger = event.target.closest && event.target.closest('[data-lightbox-src]');
      if (!trigger || !root.contains(trigger)) return;

      if (window.A24Theme?.shouldProtectEditorClicks?.()) return;
      event.preventDefault();
      openLightbox(trigger);
    });

    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', function () {
        stepLightbox(-1);
      });
    }

    if (lightboxNext) {
      lightboxNext.addEventListener('click', function () {
        stepLightbox(1);
      });
    }

    lightboxClose.forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });

    lightbox.addEventListener('touchstart', function (event) {
      // Startpunkt für mobile Swipe-Gesten merken.
      if (lightbox.hidden || event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    lightbox.addEventListener('touchend', function (event) {
      // Horizontaler Swipe wechselt Bild; vertikales Scrollen wird ignoriert.
      if (lightbox.hidden || !event.changedTouches.length) return;

      var deltaX = event.changedTouches[0].clientX - touchStartX;
      var deltaY = event.changedTouches[0].clientY - touchStartY;

      if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;
      stepLightbox(deltaX < 0 ? 1 : -1);
    }, { passive: true });

    document.addEventListener('keydown', function (event) {
      // Desktop/Tastatur: Escape schliesst, Pfeile navigieren.
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') stepLightbox(-1);
      if (event.key === 'ArrowRight') stepLightbox(1);
    });
  }

  function initQuickfactsEntrance(root) {
    // Animiert die Quickfacts einmalig, respektiert prefers-reduced-motion.
    var quickfacts = root.querySelector('.a24-kuro-landing__quickfacts');
    if (!quickfacts || quickfacts.dataset.a24QuickfactsReady === 'true') return;
    quickfacts.dataset.a24QuickfactsReady = 'true';

    var items = Array.prototype.slice.call(quickfacts.querySelectorAll('li'));
    if (!items.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasAnimated = false;

    items.forEach(function (item) {
      item.style.opacity = '0';
      item.style.transform = 'translateY(34px)';
    });

    function revealQuickfacts() {
      // Führt die gestaffelte Quickfact-Animation genau einmal aus.
      if (hasAnimated) return;
      hasAnimated = true;

      if (reduceMotion) {
        items.forEach(function (item) {
          item.style.opacity = '1';
          item.style.transform = 'none';
        });
        return;
      }

      items.forEach(function (item, idx) {
        window.setTimeout(function () {
          var anim = item.animate(
            [
              { opacity: 0, transform: 'translateY(34px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ],
            {
              duration: 1300,
              easing: 'cubic-bezier(.16,1,.3,1)',
              fill: 'forwards'
            }
          );

          anim.onfinish = function () {
            item.style.opacity = '1';
            item.style.transform = 'none';
          };
        }, idx * 220);
      });
    }

    if (reduceMotion) {
      revealQuickfacts();
      return;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealQuickfacts();
            obs.disconnect();
          }
        });
      }, { threshold: 0.35 });
      observer.observe(quickfacts);
    } else {
      window.setTimeout(revealQuickfacts, 180);
    }
  }

  function initCarousel(carouselEl) {
    // Initialisiert ein einzelnes Carousel mit Slides, Dots, Counter und Preload.
    if (carouselEl.dataset.a24CarouselReady === 'true') return;
    carouselEl.dataset.a24CarouselReady = 'true';

    var slides = Array.prototype.slice.call(carouselEl.querySelectorAll('[data-carousel-slide]'));
    if (!slides.length) return;

    var prevBtn = carouselEl.querySelector('[data-carousel-prev]');
    var nextBtn = carouselEl.querySelector('[data-carousel-next]');
    var dots = Array.prototype.slice.call(carouselEl.querySelectorAll('[data-carousel-dot]'));
    var counter = carouselEl.querySelector('[data-carousel-counter]');
    var currentIndex = 0;
    var dotsAnimated = false;

    function animateDotsEntrance() {
      // Laesst Carousel-Dots erst beim Sichtbarwerden erscheinen.
      if (dotsAnimated || !dots.length) return;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var dotsWrap = carouselEl.querySelector('.a24-carousel__dots') || carouselEl;

      function revealDots() {
        // Setzt gestaffelte Delay-Werte und aktiviert die Dot-Animation.
        if (dotsAnimated) return;
        dotsAnimated = true;

        dots.forEach(function (dot, idx) {
          dot.style.setProperty('--dot-delay', (idx * 85) + 'ms');
        });

        if (reduceMotion) {
          dots.forEach(function (dot) {
            dot.classList.add('is-visible');
          });
          return;
        }

        window.requestAnimationFrame(function () {
          dots.forEach(function (dot) {
            dot.classList.add('is-visible');
          });
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealDots();
              obs.disconnect();
            }
          });
        }, { threshold: 0.35 });
        observer.observe(dotsWrap);
      } else {
        window.setTimeout(revealDots, 180);
      }
    }

    function preloadCarouselAround() {
      // Laedt benachbarte Carousel-Bilder vor, ohne sie sichtbar zu machen.
      for (var offset = -3; offset <= 3; offset += 1) {
        if (offset === 0) continue;
        var preloadIndex = normalizeIndex(currentIndex + offset, slides.length);
        var preloadSrc = slides[preloadIndex] && slides[preloadIndex].getAttribute('data-lightbox-src');
        if (!preloadSrc) continue;
        var preloadImg = new Image();
        preloadImg.src = preloadSrc;
      }
    }

    function renderCarousel() {
      // Schaltet aktive Slide/Dot-Zustaende und aktualisiert den Zaehler.
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === currentIndex);
        slide.setAttribute('aria-hidden', idx === currentIndex ? 'false' : 'true');
      });

      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === currentIndex);
        dot.setAttribute('aria-selected', idx === currentIndex ? 'true' : 'false');
      });

      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + slides.length;
      preloadCarouselAround();
    }

    function goTo(index) {
      // Oeffentliche Carousel-Navigation für Buttons und Dots.
      currentIndex = normalizeIndex(index, slides.length);
      renderCarousel();
    }

    animateDotsEntrance();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () {
        goTo(idx);
      });
    });

    renderCarousel();
  }

  function initKuroLanding(root) {
    // Orchestriert alle KURO-Landing-Module für eine Section-Instanz.
    if (!root || root.dataset.a24KuroLandingReady === 'true') return;
    root.dataset.a24KuroLandingReady = 'true';

    initHighPriceModal(root);
    initStandardLightbox(root);
    initQuickfactsEntrance(root);
    root.querySelectorAll('[data-a24-carousel]').forEach(initCarousel);
  }

  function initAll(scope) {
    // Initialisiert vorhandene Sections und Shopify-Editor-Reloads.
    var rootScope = scope || document;
    if (rootScope.matches && rootScope.matches('[data-a24-kuro-landing]')) {
      initKuroLanding(rootScope);
    }
    if (rootScope.querySelectorAll) {
      rootScope.querySelectorAll('[data-a24-kuro-landing]').forEach(initKuroLanding);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
